/* global axios */
import ApiClient from '../ApiClient';

// The company's own actions the assistant may take. Teletel endpoints only —
// Captain's paid custom-tools API is never called.
class TeletelToolsAPI extends ApiClient {
  constructor() {
    super('teletel/tools', { accountScoped: true });
  }

  test(id, parameters = {}) {
    return axios.post(`${this.url}/${id}/test`, { parameters });
  }
}

export default new TeletelToolsAPI();
